/**
 * Quick-filter selector (top center) — one-tap presets that compose with the
 * detailed filters in the filter popout (ui/filterPanel.js). Modes:
 *   • „Alle"      – no extra restriction
 *   • „No Flybys" – hide high-cruising airliners (Verkehrsflugzeuge > 10 km)
 *   • Priorität   – placeholder for an upcoming high-priority filter (disabled)
 */
export function setupQuickFilter(flightManager) {
  const buttons = document.querySelectorAll('#quickFilter .qf-btn[data-mode]');

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      buttons.forEach((b) => {
        const active = b === btn;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', String(active));
      });
      flightManager.setFilters({ quickFilter: btn.dataset.mode });
    });
  });
}
